// Consentimiento de cookies. Lo necesario (sesión, idioma, esta elección) funciona
// siempre; el registro de visitas y clics (utils/analytics.js) solo con 'accepted'.
const CONSENT_KEY = 'cookieConsent';
const SESSION_ID_KEY = 'tp_session_id';

export const CONSENT_CHANGE_EVENT = 'cookieConsentChange';
export const OPEN_COOKIE_SETTINGS_EVENT = 'openCookieSettings';

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch (error) {
    return null;
  }
};

export const analyticsAllowed = () => getConsent() === 'accepted';

export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_KEY, value);
    // Al rechazar se borra el identificador de sesión que usan las estadísticas
    if (value !== 'accepted') sessionStorage.removeItem(SESSION_ID_KEY);
  } catch (error) {
    // Sin almacenamiento (modo privado): se trata como no aceptado
  }
  window.dispatchEvent(new Event(CONSENT_CHANGE_EVENT));
};

export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT));
